import React, { useState, useEffect, useRef } from "react";
import styles from "./job-type-modal.module.css";
import Input from "../../ui/input";
import { MyIcons } from "../../icons/my-icons";
import Button from "../../ui/button";
import Table from "../../ui/table";
import Checkbox from "../../ui/checkbox";
import { getJobTypes, createJobType, getJobTypeById, editJobType } from "../../../services/apiService";

const JobTypeModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    isInitial: false,
  });
  const [jobTypes, setJobTypes] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingJobTypeId, setEditingJobTypeId] = useState(null);

  const fetchJobTypes = async () => {
    try {
      const jobTypesData = await getJobTypes();
      setJobTypes(jobTypesData);
    } catch (error) {
      console.error("Error fetching job types:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchJobTypes();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (checked) => {
    setFormData({ ...formData, isInitial: checked });
  };

  const handleSubmit = async () => {
    try {
      const jobTypeData = {
        nombre: formData.name,
        tipoTrabajoInicial: formData.isInitial,
      };

      if (isEditMode) {
        await editJobType(editingJobTypeId, { nombre: formData.name });
      } else {
        await createJobType(jobTypeData);
      }
      
      // Refrescar la lista de tipos de trabajo
      await fetchJobTypes();
      
      // Limpiar el formulario
      setFormData({
        name: "",
        isInitial: false,
      });
      setIsEditMode(false);
      setEditingJobTypeId(null);
      
    } catch (error) {
      console.error("Error al guardar tipo de trabajo:", error);
    }
  };

  const handleRowClick = async (jobType) => {
    try {
      const jobTypeDetails = await getJobTypeById(jobType.id);
      setFormData({
        name: jobTypeDetails.nombre,
        isInitial: jobTypeDetails.tipoTrabajoInicial,
      });
      setIsEditMode(true);
      setEditingJobTypeId(jobType.id);
    } catch (error) {
      console.error("Error fetching job type details:", error);
    }
  };

  const handleCancelEdit = () => {
    setFormData({
      name: "",
      isInitial: false,
    });
    setIsEditMode(false);
    setEditingJobTypeId(null);
  };

  const headers = [
    { label: "Nombre", key: "nombre" },
    { label: "Tipo Trabajo Inicial", key: "tipoTrabajoInicial" },
  ];

  // Formatear los datos para la tabla
  const formattedJobTypes = jobTypes.map(jobType => ({
    ...jobType,
    tipoTrabajoInicial: jobType.tipoTrabajoInicial ? "Sí" : "No",
  }));

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer} ref={modalRef}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Tipos de Trabajo</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons
              name="close"
              width={24}
              height={24}
              color="black"
            />
          </button>
        </div>

        <div className={styles.formSection}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              width: "100%",
              alignItems: "flex-end",
            }}
          >
            <Input
              label="Nombre"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              style={{ flex: 1 }}
            />
            <div 
              style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "8px", 
                marginBottom: "8px",
                cursor: "pointer"
              }}
              onClick={() => handleCheckboxChange(!formData.isInitial)}
            >
              <Checkbox
                checked={formData.isInitial}
                onChange={handleCheckboxChange}
              />
              <span 
                style={{
                  color: "#000",
                  fontFamily: "var(--font-roboto)",
                  userSelect: "none"
                }}
              >
                Tipo Trabajo Inicial
              </span>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: "16px", display: "flex", gap: "12px" }}>
          <Button 
            type="button" 
            variant="primary" 
            onClick={handleSubmit}
            disabled={!formData.name.trim()}
          >
            {isEditMode ? "GUARDAR CAMBIOS" : "AÑADIR TIPO DE TRABAJO"}
          </Button>
          {isEditMode && (
            <Button type="button" variant="secondary" onClick={handleCancelEdit}>
              CANCELAR
            </Button>
          )}
        </div>

        <div className={styles.tableSection}>
          <Table 
            headers={headers} 
            data={formattedJobTypes}
            onPress={handleRowClick}
          />
        </div>
      </div>
    </div>
  );
};

export default JobTypeModal;
